import './MetasGerais.css'
import { useEffect, useRef, useState } from 'react';
import { logout } from '../../auth';
import { get, post } from '../../services/api';
import AdminSection from "../AdminSection/AdminSection";
import DownloadIcon from '@mui/icons-material/Download';

export default function MetasGerais({ setNotifier }) {

    const [ valorBase, setValorBase ] = useState('');
    const [ valorBaseCSVFileName, setValorBaseCSVFileName ] = useState(undefined);
    const [ valorBasePadrao, setValorBasePadrao ] = useState(0);
    const valorBaseCSVRef = useRef(undefined);
    const valorBasePadraoRef = useRef(undefined);

    function handleRefresh(e, type = 'all') {
        e.preventDefault();

        refreshInputs(type);
    }

    function isThirdStagePopuled() {
        const valorBaseNumber = Number(valorBase.replaceAll('.', '').replace(',', '.'))

        return  (!isNaN(valorBaseNumber) && valorBaseNumber != 0) ||
            valorBaseCSVFileName !== undefined || 
                valorBasePadrao !== 0;  
    }

    function refreshInputs(type = 'all') {
        setValorBase('');
        setValorBaseCSVFileName(undefined);
        if(valorBaseCSVRef.current?.value != undefined) valorBaseCSVRef.current.value = null;
        setValorBasePadrao(0);
        if(valorBasePadraoRef.current?.value != undefined) valorBasePadraoRef.current.checked = false;
    }

    async function handleValorBaseSubmit(event){
        event.preventDefault();

        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const formData = new FormData(event.target);

            formData.append('idusuario', idUsuarioAtual);

            const { response } = await post('/admin/painelbordo/metas-gerais', formData, authToken, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if(response?.status >= 400){
                setNotifier(false, response.data)
            }
            else{
                setNotifier(true, 'Enviado com sucesso')
            }
        }
    }

    function baixarExemploCSV() {
        const csvData = [
            ['Cod. Filial', 'Mes', 'Ano', 'Venda Ideal', 'Venda Desafio', 'Venda Projetada', 'Juros Ideal', 
                'Juros Desafio', 'Juros Projetado', 'VP Ideal', 'VP Desafio', 'VP Projetado'],
        ];

        const csvContent = csvData.map(e => e.join(";")).join("\n");
        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'exemploMetasGerais.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return <>
    <AdminSection
        etapa={1} titulo={'Importar metas gerais'} 
    >
        <form onSubmit={handleValorBaseSubmit}>
            <div className='p-8' style={{paddingBottom: "16px"}}>
                <div className="texto-csv">
                    <span className="bold-text">Importe seu arquivo clicando no botão abaixo</span>
                    <div className="normal-text">O arquivo deve ser em formato CSV(Separado por virgulas).</div>
                </div>
                <div className='importar-csv'>
                    <label htmlFor="valorBaseCSV" className= {`btn-label {valorBase != '' || valorBasePadrao !== 0 ? 'disabled' : ''}`}>Importar CSV</label>
                        <input type="file" accept='.csv' ref={valorBaseCSVRef} name='valorBaseCSV' id="valorBaseCSV" onChange={(e) => {
                            const uploadedFile = e.target.files[0];
                            if (uploadedFile) {
                                setValorBaseCSVFileName(uploadedFile.name);
                            }
                        }} disabled={valorBase != '' || valorBasePadrao !== 0}/>
                    <label className='muda-nome'>{valorBaseCSVFileName === undefined ? '' : valorBaseCSVFileName}</label>
                </div>
            </div>
            <div className='animal-valorBase-buttons' style={{textAlign: "center", padding: "0px"}}>
                        <button 
                            className='animal-refresh-btn' 
                            onClick={(e) => handleRefresh(e, 'metaBase')}>Cancelar
                        </button>
            </div>
            <div className="button-container">
                <button type="button" className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon 
                style={{width: '25px', height: '25px', marginRight: '10px'}}/> Exportar modelo</button>

                <button className='animal-save-btn' disabled={!isThirdStagePopuled()}>Enviar CSV</button>
            </div>
        </form>     
    </AdminSection>
</>
}